/**
 * extract.ts — the one place that pulls the optional `widgets` array off an
 * untrusted carrier (WS `final.data` OR persisted message `metadata`), so the
 * live path and the history-replay path thread widgets identically. Returns
 * undefined (not []) when absent/malformed, so a widget-less message stays clean.
 */
import { CopilotWidget } from '../lib/copilotTypes'

export const widgetsFrom = (source?: { widgets?: unknown } | null): CopilotWidget[] | undefined =>
  source && Array.isArray(source.widgets) ? (source.widgets as CopilotWidget[]) : undefined
